module.exports = __webpack_public_path__ + "img/clients.11c334dc.svg";